import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _identity from 'lodash/identity';

import { DropdownPropTypes } from './Dropdown';

import './MenuItem.scss';

export const MenuItemPropTypes = {
  getText: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  isSelected: PropTypes.func,
  isHighlighted: PropTypes.func,
  onSelect: PropTypes.func,
  renderMenuItem: PropTypes.func,
  className: PropTypes.string,
  isTitle: PropTypes.bool,
  noCloseOnSelect: PropTypes.bool,
};

export const MenuItemDefaultProps = {
  getKey: _identity,
  getText: _identity,
  isSelected: () => false,
  isHighlighted: () => false,
  onSelect: _identity,
  renderMenuItem: _identity,
  noCloseOnSelect: false,
};

class MenuItem extends Component {
  static propTypes = {
    ...MenuItemPropTypes,
    ...DropdownPropTypes,
  };

  static defaultProps = {
    ...MenuItemDefaultProps,
    toggleMenu: _identity,
  };

  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { item: prevItem, isHighlighted: prevIsHighlighted } = prevProps;
    const { item: currentItem, isHighlighted: currentIsHighlighted } = this.props;
    const { current } = this.node;
    const wasHighlighted = prevIsHighlighted(prevItem);
    const isHighlighted = currentIsHighlighted(currentItem);

    if (!wasHighlighted && isHighlighted && current) {
      current.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
      });
    }
  }

  handleClick = event => {
    const { item, onSelect, toggleMenu, noCloseOnSelect } = this.props;

    if (!noCloseOnSelect) {
      toggleMenu(event);
    }
    onSelect(item);
  };

  render() {
    const { item, getText, isSelected, isHighlighted, renderMenuItem, className, isTitle, selectedRef } = this.props;
    const isSelectedItem = isSelected(item);
    const classes = classNames(
      {
        'dropdown-menu-item': true,
        'dropdown-menu-item--item': !isTitle,
        'dropdown-menu-item--title': isTitle,
        'dropdown-menu-item--selected': isSelectedItem,
        'dropdown-menu-item--highlighted': isHighlighted(item),
      },
      className
    );
    const text = typeof getText === 'string' ? item[getText] : getText(item);
    const refProps = {};

    if (selectedRef && isSelectedItem) {
      refProps.ref = selectedRef;
    }

    return (
      <button type="button" className={classes} onClick={this.handleClick} ref={this.node} {...refProps}>
        {renderMenuItem(text, isSelectedItem, item)}
        {item.icon && (
          <span className="dropdown-menu-item__icon">
            <img src={item.icon} alt={item.label} />
          </span>
        )}
      </button>
    );
  }
}

export default MenuItem;
